import './Header.scss';
import 'Components/PhoneComponent/PhoneComponent';
import 'Components/Button/Button';
class Header {
	constructor( node ) {
		this.node = node;
	}
	init() {
		var t = this;
		// -- header color -- //
			if( !document.querySelector('.StatueSlider') ) {
				var header = document.querySelector('header');
				window.addEventListener('scroll', function() {
					if( window.scrollY > header.offsetHeight && !header.classList.contains('Header--color') ) {
						header.classList.add('Header--color');
					} else if( window.scrollY < header.offsetHeight && header.classList.contains('Header--color') ) {
						header.classList.remove('Header--color');
					}
				});
				if( window.scrollY > header.offsetHeight && !header.classList.contains('Header--color') ) {
					header.classList.add('Header--color');
				}
			}
		// -- END -- //

		// -- additional phones -- //
			var phonesBox = t.node.querySelector('.right__phones');
			var phonesButton = phonesBox.querySelector('.phones__button');
			if( phonesButton ) {
				phonesButton.addEventListener('click', function(e) {
					e.stopPropagation();
					phonesButton.classList.toggle('active');
				});
				document.addEventListener('click', function() {
					phonesButton.classList.remove('active');
				});
			}
		// -- END -- //

	}
}
JSModules['Header'] = Header;
export default Header;